import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingUnderline: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 0H2v6a6 6 0 1 0 12 0V0H9v7H7zm9 16v-3H0v3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingUnderline
